<kendo-dialog-titlebar>
    {{'shared.header.chooseText' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">

        <text-input-ctrl *ngIf="!useTextArea" [caption]="label | translate"
            [formControlName]="'selectedText'" [settings]="{fxFill:true}"></text-input-ctrl>

        <textarea-input-ctrl *ngIf="!!useTextArea"  [caption]="label | translate"
            [formControlName]="'selectedText'" [settings]="{fxFill:true,rows:5}">
        </textarea-input-ctrl>
           
    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>